import React, { useState, useEffect } from "react";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import { Row, Col } from "reactstrap";
import axios from "axios";
import { serverUrl } from "../../../../libs/Apollo";
import Pagination from "../../../../components/Pagination/Pagination";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";

const AttendanceQuery = gql`
  query getAllData(
    $user_code: String
    $fullname: String
    $start_date: String
    $end_date: String
    $page: Int
  ) {
    getAttendances(
      user_code: $user_code
      fullname: $fullname
      start_date: $start_date
      end_date: $end_date
      page: $page
    ) {
      count
      rows {
        id
        user_code
        fullname
        attendance_date
        entry_at
        exit_at
        attendance_status
      }
    }
  }
`;

const Columns = [
  {
    text: "No",
    dataField: "id",
    isDummyField: true,
    headerAlign: "center",
    formatter: (c, r, index, b) => {
      return index + 1;
    },
  },
  {
    text: "Name",
    dataField: "fullname",
    headerAlign: "center",
  },
  {
    text: "Attendance Date",
    dataField: "attendance_date",
    headerAlign: "center",
    formatter: (c) => <div className="text-center">{c}</div>,
  },
  {
    text: "Entry At",
    dataField: "entry_at",
    headerAlign: "center",
    formatter: (c) => <div className="text-center">{c}</div>,
  },
  {
    text: "Exit At",
    dataField: "exit_at",
    headerAlign: "center",
    formatter: (c) => <div className="text-center">{c}</div>,
  },
  {
    text: "Attendance Status",
    dataField: "attendance_status",
    headerAlign: "center",
    formatter: (c) => <div className="text-center">{c}</div>,
  },
];
const Attendance = (props) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 50,
    count: 0,
  });
  const [search, setSearch] = useState({
    user_code: "",
    fullname: "",
    start_date: "",
    end_date: "",
  });
  const [enterSearch, setEnterSearch] = useState({
    user_code: "",
    fullname: "",
    start_date: "",
    end_date: "",
  });
  const { data, loading, error, refetch } = useQuery(AttendanceQuery, {
    variables: {
      user_code: "",
      fullname: enterSearch.fullname,
      start_date: enterSearch.start_date,
      end_date: enterSearch.end_date,
      page: pagination.page,
    },
  });

  const [importAttendance, setImportAttendance] = useState(false);
  const [fileAttendance, setFileAttendacen] = useState(false);
  const [filename, setFilename] = useState("");

  function handleFile(file) {
    setFileAttendacen(file.target.files[0] || false);
    let fileAttendanceName =
      file.target.files[0] !== undefined
        ? file.target.files[0].name !== undefined
          ? file.target.files[0].name
          : null
        : null;
    setFilename(fileAttendanceName);
  }

  function handleSearch() {
    setEnterSearch({
      user_code: search.user_code,
      fullname: search.fullname,
      start_date: search.start_date,
      end_date: search.end_date,
    });
  }

  function handleReset() {
    setEnterSearch({
      user_code: "",
      fullname: "",
      start_date: "",
      end_date: "",
    });
    setSearch({
      user_code: "",
      fullname: "",
      start_date: "",
      end_date: "",
    });
  }

  async function handleUpload() {
    // setAttendanceFile(file.target.files[0].name || false);
    setImportAttendance(true);
    if (fileAttendance) {
      let formData = new FormData();
      formData.append("file", fileAttendance);
      try {
        let upload = await axios.post(
          `${serverUrl}/import_attendance`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (upload) {
          setImportAttendance(false);
          alertNotify("Success!", "Import Attendance File!", "success");
          refetch();
        }
      } catch (error) {
        // console.log(error);
        setImportAttendance(false);
        alertNotify("Failed!", "Import Attendance File", "danger");
      }
    }
  }

  useEffect(() => {
    if (data) {
      setPagination({ ...pagination, count: data.getAttendances.count });
    }
  }, [data]);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      page: parseInt(page),
    });
  };

  const alertNotify = (title, message, type) => {
    store.addNotification({
      title: title,
      message: message,
      type: type,
      container: "top-left",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      width: 300,
      dismiss: {
        duration: 4000,
      },
      showIcon: true,
    });
  };

  return (
    //jsx Fragment
    <>
      <div className="section p5">
        <div className="sectioncontent">
          <h5 className="blocktext">List Attendance</h5>
          <Row className="px-3">
            <Col md="12">
              <Row className="">
                <Col md="12">
                  <Row className="py-2">
                    <Col md="4">
                      <div className="form-group">
                        <label>Import Attendance</label>
                        <div className="input-group mb-3">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="inputGroupFile02"
                              onChange={handleFile}
                            />
                            <label
                              className="custom-file-label"
                              for="inputGroupFile02"
                            >
                              {/* Choose file Attendance */}
                              {filename}
                            </label>
                          </div>
                          {fileAttendance && (
                            <div className="input-group-append">
                              <button
                                type="button"
                                className={`input-group-text bg-${
                                  !fileAttendance
                                    ? "outline-success text-dark"
                                    : "success text-white"
                                } `}
                                onClick={handleUpload}
                                disabled={importAttendance || !fileAttendance}
                              >
                                <i
                                  className={`fa fa-${
                                    importAttendance
                                      ? "spin fa-spinner"
                                      : "upload"
                                  } mr-1`}
                                ></i>
                                Import
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col />
                    <Col md="3">
                      <div className="form-group">
                        <label for="exampleInputPassword1">Employee Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputPassword1"
                          value={search.fullname}
                          onChange={({ target }) =>
                            setSearch({ ...search, fullname: target.value })
                          }
                        />
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="form-group">
                        <label>Date Range</label>
                        <div className="input-group">
                          <input
                            type="date"
                            className="form-control"
                            value={search.start_date}
                            onChange={({ target }) =>
                              setSearch({ ...search, start_date: target.value })
                            }
                          />
                          <input
                            type="date"
                            className="form-control"
                            value={search.end_date}
                            onChange={({ target }) =>
                              setSearch({ ...search, end_date: target.value })
                            }
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="8"></Col>
                    <Col md="4">
                      <div className="pull-right">
                        <button
                          type="button"
                          className="btn btn-success mr-1"
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search mr-1"></i>Search
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={handleReset}
                        >
                          <i className="fa fa-history mr-1"></i>Reset
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md="12">
                      {loading && (
                        <h4>
                          <i className="fa fa-spin fa-spinner"></i> Please
                          Wait...
                        </h4>
                      )}
                      {error && (
                        <div>
                          <h5>Some Error Occured</h5>
                        </div>
                      )}
                      <Pagination
                        noDataIndication={() => (
                          <h5 className="text-center">No Data</h5>
                        )}
                        keyField="id"
                        bootstrap4={true}
                        page={pagination.page}
                        sizePerPage={pagination.limit}
                        totalSize={pagination.count}
                        onTableChange={handleTableChange}
                        data={data ? data.getAttendances.rows : []}
                        columns={Columns}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default Attendance;
